module.exports = __webpack_public_path__ + "img/194-bdc80e.png";